"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WarnChanges = /*#__PURE__*/function (_React$Component) {
  _inherits(WarnChanges, _React$Component);

  var _super = _createSuper(WarnChanges);

  function WarnChanges() {
    var _this;

    _classCallCheck(this, WarnChanges);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleUnload", function (_e) {
      var _this$props = _this.props,
          beforeUnloadTasks = _this$props.beforeUnloadTasks,
          hasChanges = _this$props.hasChanges;

      if (hasChanges && beforeUnloadTasks) {
        beforeUnloadTasks(location);
        return true;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleBeforeUnload", function (e) {
      var confirmationMessage = '_'; // Don't remove

      e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+

      return confirmationMessage; // Gecko, WebKit, Chrome <34
    });

    return _this;
  }

  _createClass(WarnChanges, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.hasChanges) {
        // Important that this use window.onbeforeunload rather than window.addEventListener('beforeunload, ...) so that
        // it can be overidden anywhere in the app, namely by the inactivity timer.
        window.onbeforeunload = this._handleBeforeUnload;
      }

      window.addEventListener('unload', this._handleUnload);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.hasChanges && this.props.hasChanges) {
        window.onbeforeunload = this._handleBeforeUnload;
      }

      if (prevProps.hasChanges && !this.props.hasChanges) {
        window.onbeforeunload = null;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onbeforeunload = null;
      window.removeEventListener('unload', this._handleUnload);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasChanges = _this$props2.hasChanges,
          beforeUnloadTasks = _this$props2.beforeUnloadTasks,
          className = _this$props2.className;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Prompt, {
        className: "".concat(className, " WarnChanges__Prompt"),
        when: hasChanges,
        message: function message(location) {
          if (_this2.props.location.pathname === location.pathname) {
            return true;
          }

          if (window.confirm('Are you sure you want to leave? Changes you made will be lost.')) {
            beforeUnloadTasks && beforeUnloadTasks(location);
            return true;
          }

          return false;
        }
      });
    }
  }]);

  return WarnChanges;
}(_react.default.Component);

WarnChanges.defaultProps = {
  hasChanges: false,
  location: {},
  beforeUnloadTasks: function beforeUnloadTasks() {},
  className: ''
};
WarnChanges.propTypes = {
  hasChanges: _propTypes.default.bool,
  location: _propTypes.default.object,
  beforeUnloadTasks: _propTypes.default.func,
  className: _propTypes.default.string
};

var _default = (0, _reactRouterDom.withRouter)(WarnChanges);

exports.default = _default;
//# sourceMappingURL=WarnChanges.js.map